// import objectHelper from "@/classes/helpers/objectHelper";
import * as GARANTIES from "@/classes/parametrage/garanties";
import objectHelper from "../helpers/objectHelper";

export default {
  /*
   * Récupération du paramétrage des garanties pour un type de garantie donnée triée par un critère donné pour une option donnée
   */
  getParametragesGaranties(idType, idGarantie, idOption, idCritere) {
    var parametrages = GARANTIES.PARAMETRAGE.types
      .find((x) => x.idType == idType)
      .garanties.filter((x) => x.idGarantie == idGarantie)
      .filter((x) => x.idCritere == idCritere);

    parametrages.forEach((p) => {
      var parametrage = p.parametrage.find((x) => x.idOption == idOption);
      p.tauxOption = parametrage.taux;
      p.offset = objectHelper.isDefined(parametrage.offset) ? parametrage.offset : 0;
    });

    return parametrages;
  },
};
